var map = {
	"./1_for_doctor.png": 8248,
	"./2_example_report_common.png": 7187,
	"./3_example_report_short.png": 4299,
	"./4_example_report_graphic.png": 3304,
	"./arrow_down.png": 3003,
	"./arrow_up.png": 1192,
	"./bm_farm.png": 8203,
	"./bm_ins.png": 683,
	"./bm_lab.png": 6082,
	"./bm_pat.png": 6744,
	"./download_arrow.png": 595,
	"./download_arrow_hover.png": 5668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1978;